import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useSpace } from 'contexts/space';
import { hardRedirect } from 'utils/link';

const SpaceRedirect = ({ to }) => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const { selectSpace } = useSpace();

  useEffect(() => {
    if (params.spaceId) {
      selectSpace(params.spaceId);
    }

    let target = to;
    Object.entries(params).forEach(([key, value]) => {
      if (value) target = target.replace(`:${key}`, value);
    });

    const search = searchParams.toString();
    if (search) target = `${target}?${search}`;

    hardRedirect(target);
  }, [params, to, searchParams, selectSpace]);

  return null;
};

export default SpaceRedirect;
